import { useState } from "react";


export default function QATab({ questions, dealId }) {
    const handleClickFaq = (faqId, e) => {
        e.stopPropagation();
        setOpenId((prev) => (prev === faqId ? null : faqId));
    }
    const [openId, setOpenId] = useState(0);


    const PublicQuestions = () => {
        const publicQuestions = questions.filter((x) => !x.deal);

        return (
            <div className="card">
                <div className="section-card" style={{ border: "none", height: "33vh", padding: "20px" }}>
                    <h4>Public Q&A</h4>
                    <div style={{ overflowY: "auto", maxHeight: "80%" }}>
                        {publicQuestions.map((faq) => (
                            <div key={faq?._id} className="faq-item list-group-item" style={{ marginTop: "1rem", marginBottom: "10px" }} >
                                <button className="btn btn-toggle w-100 text-start d-flex justify-content-between align-items-center" onClick={(e) => handleClickFaq(faq?._id, e)} >
                                    <span>{faq?.title}</span>
                                    <div className="d-flex gap-4">
                                        <i className={`bi ${openId === faq?._id ? "bi-chevron-up" : "bi-chevron-down"}`} />
                                    </div>

                                </button>
                                {openId === faq?._id && (
                                    <div className="faq-answer text-muted mt-2">
                                        {faq?.responseFaq}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    const PrivateQuestions = () => {
        const privateQuestions = questions.filter((x) => x.deal === dealId);

        return (
            <div className="card" style={{ borderRadius: "4px", padding: "20px" }}>
                <div className="section-card" style={{ border: "none", height: `33vh` }} >
                    <h4>Private Q&A</h4>
                    <div style={{ overflowY: "auto", maxHeight: "80%" }}>
                        {privateQuestions?.map((faq) => (
                            <div key={faq?._id} className="faq-item list-group-item" style={{ marginTop: "1rem", marginBottom: "10px" }} >
                                <button className="btn btn-toggle w-100 text-start d-flex justify-content-between align-items-center" onClick={(e) => handleClickFaq(faq?._id, e)} >
                                    <span>{faq?.title}</span>
                                    <div className="d-flex gap-4">
                                        <i className={`bi ${openId === faq?._id ? "bi-chevron-up mt-1" : "bi-chevron-down mt-1"}`} />
                                    </div>

                                </button>
                                {openId === faq?._id && (

                                    <div className={`faq-answer text-muted mt-2 ${!faq?.responseFaq ? "fst-italic" : ""}`}>
                                        {faq?.responseFaq || "No response yet"}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div >
        )
    }


    return (
        <div className="d-flex gap-2 flex-column" style={{ gap: "4px" }}>
            <PublicQuestions />
            <PrivateQuestions />
        </div>
    );
}